import React from "react";




const cars = [
  {
    id: 1,
    name: "Innova Cab",
    image: "/images/Fleet/Innova-Cab.jpg",
    seats: "7 Seats",
    bags: "4 Bags",
    type: "SUV",
    fuel: "Diesel",
  },
  {
    id: 2,
    name: "Innova Crysta",
    image: "/images/Fleet/Innova-Crysta.jpg",
    seats: "7 Seats",
    bags: "4 Bags",
    type: "SUV",
    fuel: "Diesel",
  },
  {
    id: 3,
    name: "Kia Carens",
    image: "/images/Fleet/Kia-Carens.jpg",
    seats: "6 Seats",
    bags: "3 Bags",
    type: "MUV",
    fuel: "Petrol",
  },
  {
    id: 4,
    name: "Maruti Ertiga",
    image: "/images/Fleet/Maruti-Ertiga.jpeg",
    seats: "7 Seats",
    bags: "3 Bags",
    type: "MUV",
    fuel: "Petrol / CNG",
  },
  {
    id: 5,
    name: "Mini Bus",
    image: "/images/Fleet/Mini-Bus.jpg",
    seats: "25 Seats",
    bags: "20 Bags",
    type: "Mini Bus",
    fuel: "Diesel",
  },
  {
    id: 6,
    name: "Swift Dzire",
    image: "/images/Fleet/Swift-Dzire.jpg",
    seats: "4 Seats",
    bags: "2 Bags",
    type: "Sedan",
    fuel: "Petrol",
  },
  {
    id: 7,
    name: "Tempo Traveller",
    image: "/images/Fleet/Tempo-Traveller.jpeg",
    seats: "17 Seats",
    bags: "10 Bags",
    type: "Traveller",
    fuel: "Diesel",
  },
  {
    id: 8,
    name: "Toyota Rumion",
    image: "/images/Fleet/Toyota-Rumion.jpeg",
    seats: "7 Seats",
    bags: "3 Bags",
    type: "MUV",
    fuel: "Petrol",
  },
  {
    id: 9,
    name: "Urbania Bus",
    image: "/images/Fleet/Urbania-Bus.jpg",
    seats: "17 Seats",
    bags: "12 Bags",
    type: "Luxury Van",
    fuel: "Diesel",
  },
];

const Ourfleets = () => {
  return (


    <>




 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Our Fleets
        </h2>
      </div>
    </section>

 

    <div className="section-full p-t150 p-b120 site-bg-white twm-cars-section-wrap">
      <div className="container">
        <div className="section-content">
          <div className="twm-cars-section m-b30">
            <div className="row">
              {cars.map((car) => (
                <div
                  key={car.id}
                  className="col-lg-4 col-md-6 m-b30 wow fadeInDown"
                  data-wow-delay="0.2s"
                >
                  <div className="twm-vehicle-fleet-bx twm-custom-grid-3">
                    <div className="twm-media">
                      <div className="twm-media-pic">
                        <img src={car.image} alt={car.name} />
                      </div>

                
                    </div>

                    {/* <div className="twm-vehicle-fleet-content">
                      <h3 className="twm-v-title text-center">
                        <a>{car.name}</a>
                      </h3>

                      <ul className="twm-vehicle-facility">
                        <li>
                          <span>
                            <img
                              src="images/icons/car-seat.svg"
                              alt="Seat"
                            />
                          </span>
                          4 Seat
                        </li>

                        <li>
                          <span>
                            <img
                              src="images/icons/bag.svg"
                              alt="Bag"
                            />
                          </span>
                          4 Bags
                        </li>

                        <li>
                          <span>
                            <img
                              src="images/icons/car.svg"
                              alt="SUV"
                            />
                          </span>
                          SUV
                        </li>
                      </ul>

                      <ul className="twm-vehicle-fuel-type">
                        <li>Petrol</li>
                        <li>
                          <del>Diesel</del>
                        </li>
                        <li>
                          <del>Electric</del>
                        </li>
                      </ul>
                    </div> */}

             <div className="twm-vehicle-fleet-content">

    <h3 className="fleet-title text-white">
        {car.name}
    </h3>

    <div className="fleet-info">

        <div className="fleet-item">
            <i className="fa-solid fa-chair"></i>
            <span>{car.seats}</span>
        </div>

        <div className="fleet-item">
            <i className="fa-solid fa-suitcase"></i>
            <span>{car.bags}</span>
        </div>

        <div className="fleet-item">
            <i className="fa-solid fa-car-side"></i>
            <span>{car.type}</span>
        </div>

        <div className="fleet-item">
            <i className="fa-solid fa-gas-pump"></i>
            <span>{car.fuel}</span>
        </div>

    </div>

    <a href="/booking" className="fleet-btn">
        Book Now
        <i className="fa-solid fa-arrow-right"></i>
    </a>

</div>
                  </div>
                </div>
              ))}
            </div>

          
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Ourfleets;